<template>
    <div class="modal-dialog custom-import-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title text-danger" style="text-transform:uppercase;">{{ title }} </h4>
                <button type="button" class="close" aria-label="Close" @click="onClose()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="card">
                    <div class="card-body table-responsive p-0" style="max-height: 400px;">
                        <table class="table table-head-fixed text-nowrap">
                            <thead>
                                <tr>
                                    <th>Dòng dữ liệu</th>
                                    <th v-for="item in dataTitle" :key="item.columnId">{{ item.columnTitle }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in dataImport" :key="item.rowIndex">
                                    <td>{{ item.rowIndex }}</td>
                                    <td v-for="(field, key) in item.data" :key="key">
                                        <!-- <span>{{ field || 'Lỗi không xác định'  }}</span> -->
                                        <span v-if="!field.isError">{{ field.value }}</span>
                                        <span v-else style="background-color: red;" :title="field.error" >{{ field.value  }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                    </td>
                                    <!-- <td v-for="(field, key) in item" :key="key">
                                        <span v-if="!field.isError">{{ field.value }}</span>
                                        <span v-else style="color: red;">{{ field.error }}</span>
                                    </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-outline-dark pull-left"
                    @click="onClose()">&nbsp;Thoát</button>
                <button v-if="displaySubmit" type="button"
                    class="pull-right btn btn-outline-success" @click="onSubmit();">&nbsp;Import</button>
            </div>
        </div>
    </div>

</template>
<script>
import { ref, toRefs, watch } from "vue";
import $ from 'jquery';
import excelDataModel from '@/models/general/excelData.model'
export default {
    name: "TheDataImportShow",
    props: {
        title: String,
        confirmLabelButton: String,
        onClose: Function,
        onSubmit: Function,
        displaySubmit: Boolean,
        dataTitle: Array,
        dataImport: Array,
    },
    methods: {
    },
    watch: {
        dataImport: {
            handler(newVal) {
                console.log("dataImport changed: ", newVal);
                // Any logic to handle changes in dataImport
            },
            deep: true,
        },

        displaySubmit: {
            handler(newVal) {
                console.log("displaySubmit changed: ", newVal);
                // Any logic to handle changes in dataImport
            },
            deep: true,
        }
    },
    async mounted() {
        console.log(this.displaySubmit)
    },
}

</script>
<style>
.custom-import-dialog {
    max-width: 80% !important;
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
    margin-left: auto !important;
    margin-right: auto !important;
    position: relative !important;
    width: auto !important;
    pointer-events: none !important;
    overflow: hidden !important;
}
</style>